<template>
    <BaseForm>
        <template #title> Заполните первичные данные</template>
            <v-form ref="form">
                <v-row>
                    <Field v-for="name in [
                            'fio',
                            'birthdate',
                            'gender',
                            'birthplace',
                            'income',
                            'passport',
                            'issueDate',
                            'divisionCode',
                            // 'issuePlace',
                            'issuedBy',
                            'registrationAddress',
                            'residentialAddress',
                            'isAddressesMatches',
                            'email',
                            'personalDataProcessing',
                            // 'sopd'
                        ]" 
                        :key="name"
                        :anketaName="name"
                        />
                </v-row>
            </v-form>
            <!-- <CodeSMS @success="isDisabled = false"/> -->
        <template #buttons>
            <Button white>Вернуться</Button>
            <Button 
                @click="next"
                :disabled="isDisabled"
                :loading="isLoading"
                style="float: right"
                >
                Отправить
            </Button>
        </template>
    </BaseForm>
</template>

<script>
import CodeSMS from "../controls/CodeSMS.vue";

export default {
    components: {
        CodeSMS
    },
    data: () => ({
        // isDisabled: true,
        isDisabled: false,
        isLoading: false,
    }),
    methods: {
        next() {
            if (this.$refs.form.validate()) {
                this.isLoading = true;

                this.$connector.SendShortApplication().then(
                    data => {
                        this.isLoading = false;

                        if (data.isSuccess) {
                            this.$forms.open('Additional')
                        }
                    }
                );
                
            }
        },
        
    },
}
</script>